import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/$owner/agents/connect")({
	component: () => <Outlet />,
});
